<template>
  <div>
    <div
      style="margin-bottom: 28px; display: flex; flex-direction: row; justify-content: space-between; align-items: center;"
      class="flex-wrap"
    >
      <h2 style="font-weight: 600; font-size: 18px; margin-bottom: 0;">
        History QR
      </h2>
      <div style="position: relative; min-width: 240px;">
        <input
          v-model="search"
          type="text"
          placeholder="Search by Package Number"
          class="form-control"
          style="padding-right: 32px; height: 32px;"
          @input="onSearchInput"
        />
        <i
          class="fa fa-search"
          style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); color: #9CA3AF; pointer-events: none;"
        ></i>
      </div>
    </div>

    <div class="bg-white rounded shadow-sm">
      <div class="d-flex flex-row align-items-center justify-content-between mb-3" style="padding: 20px">
        <h3 class="h5 font-weight-semibold" style="color: #2F2F2F;">History QR</h3>
        <div class="d-flex flex-row align-items-center">
          <div class="d-flex flex-row align-items-center">
            <div style="width: 220px; margin-left: 16px;">
              <MultiSelect
                v-model="dealer"
                :options="dealerOptions.map(x => x.code)"
                :custom-label="opt => dealerOptions.find(x => x.code == opt)
                  ? (dealerOptions.find(x => x.code == opt).name.length > 16
                    ? dealerOptions.find(x => x.code == opt).name.substring(0, 16) + '...'
                    : dealerOptions.find(x => x.code == opt).name)
                  : opt"
                class="qtrust-select"
                placeholder="All Dealer"
              ></MultiSelect>
            </div>
            <div style="width: 180px; margin-left: 20px;">
              <MultiSelect
                v-model="status"
                :options="['INTRANSIT' , 'RECEIVED']"
                class="qtrust-select"
                placeholder="All Status"
              ></MultiSelect>
            </div>
          </div>
        </div>
      </div>
      <div class="w-100 overflow-auto">
        <table class="table w-100 qtrust-table">
          <thead>
            <tr>
              <th style="width: 16px;"></th>
              <th>No Package</th>
              <th>Total QR Terpakai</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="3">Loading...</td>
            </tr>
            <tr v-else-if="!rows.length">
              <td colspan="3">No data</td>
            </tr>
            <template v-else v-for="(row, index) in rows">
              <tr :key="row.code || index">
                <td>
                  <button
                    type="button"
                    class="btn btn-link p-0"
                    style="line-height: 1; vertical-align: middle; margin-right: 6px;"
                    @click="toggleIssue(row.code)"
                    :disabled="!row.code"
                  >
                    <img
                      src="@/assets/img/svg/arrow-dropdown.svg"
                      alt="arrow"
                      :style="{
                        width: '16px',
                        height: '16px',
                        verticalAlign: 'middle',
                        transform: isExpanded(row.code) ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.2s ease',
                        opacity: row.code ? 1 : 0.5,
                      }"
                    />
                  </button>
                </td>
                <td>
                  {{ row.code || '-' }}
                </td>
                <td>{{ row.qty != null ? numberWithCommas(row.qty) : '-' }}</td>
              </tr>
              <tr v-if="isExpanded(row.code)" :key="`${row.code || index}-issue`">
                <td colspan="3">
                  <div style="padding: 12px 16px;">
                    <div v-if="issueLoading[row.code]">Loading issues...</div>
                    <div v-else-if="!issueRows[row.code] || !issueRows[row.code].length">
                      Tidak ada data
                    </div>
                    <div v-else class="w-100 overflow-auto">
                      <table class="table qtrust-table" style="margin-bottom: 0;">
                        <thead>
                          <tr>
                            <th class="text-nowrap">Tanggal Pengiriman</th>
                            <th class="text-nowrap">Jumlah QR</th>
                            <th class="text-nowrap">ID AHM</th>
                            <th class="text-nowrap">Kode Dealer</th>
                            <th class="text-nowrap">Nama Dealer</th>
                            <th class="text-nowrap">Kota/Kabupaten</th>
                            <th class="text-nowrap">Status Jaringan</th>
                            <th class="text-nowrap">Status</th>
                            <th class="text-nowrap">Kode BAST</th>
                            <th class="text-nowrap">Nama Pengirim</th>
                            <th class="text-nowrap">Tanggal Receipt</th>
                            <th class="text-nowrap">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(issue, issueIndex) in issueRows[row.code]" :key="issueIndex">
                            <td class="text-nowrap">{{ formatIssueDate(getIssueValue(issue, ['delivery_at'], null)) }}</td>
                            <td class="text-nowrap">{{ formatIssueQty(getIssueValue(issue, ['qty'], 0)) }}</td>
                            <td class="text-nowrap">{{ getIssueValue(issue, ['ahm_id']) }}</td>
                            <td class="text-nowrap">{{ getIssueValue(issue, ['kode_dealer']) }}</td>
                            <td class="text-nowrap">{{ getIssueValue(issue, ['dealer']) }}</td>
                            <td class="text-nowrap">{{ getIssueValue(issue, ['city']) }}</td>
                            <td class="text-nowrap">{{ getIssueValue(issue, ['h3']) ? 'Jaringan H3' : 'Jaringan H2' }}</td>
                            <td class="text-nowrap">{{ getIssueValue(issue, ['status']) }}</td>
                            <td class="text-nowrap">{{ getIssueValue(issue, ['bast_no']) }}</td>
                            <td class="text-nowrap">{{ getIssueValue(issue, ['sender_name']) }}</td>
                            <td class="text-nowrap text-right">
                              {{ formatIssueDate(getIssueValue(issue, ['received_at'], null)) }}
                              <i
                                class="fa fa-file-download ml-2"
                                style="cursor: pointer;"
                                title="Download BAST"
                                @click="printReceiptMethod(issue)"
                              ></i>
                            </td>
                            <td>
                              <div class="d-flex align-items-center">
                                <router-link
                                  v-if="issue && issue.id"
                                  :to="`/qr-code/history/detail/${issue.id}`"
                                  class="text-primary mr-2"
                                  style="cursor: pointer;"
                                  title="Detail"
                                >
                                  Detail
                                </router-link>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-end align-items-center py-2 px-3" v-if="rows && rows.length">
        <p class="text-muted mb-0">Showing {{ (config.page-1)*config.limit+1 }}-{{ (config.page-1)*config.limit+rows.length }} of {{ config.total }} items</p>
        <div class="d-flex align-items-center text-muted ml-3">
          <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page <= 1" @click="goToPage(1)"><i class="fa fa-angle-double-left"></i></button>
          <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page <= 1" @click="goToPage(config.page - 1)"><i class="fa fa-angle-left"></i></button>
          <p class="px-2 text-dark mb-0">{{ config.page }}</p>
          <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page >= config.lastPage" @click="goToPage(config.page + 1)"><i class="fa fa-angle-right"></i></button>
          <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page >= config.lastPage" @click="goToPage(config.lastPage)"><i class="fa fa-angle-double-right"></i></button>
        </div>
      </div>
    </div>
    <print-receipt ref="printReceiptComponent" :data="receiptData" />
  </div>
</template>

<script>
import PrintReceipt from "../QRIssue/children/printReceipt.vue";

export default {
  metaInfo: {
    title: "QR History",
  },
  data() {
    return {
      receiptData: null,
      rows: [],
      loading: false,
      dealer: null,
      status: null,
      search: '',
      searchTimeout: null,
      expandedRows: {},
      issueLoading: {},
      issueRows: {},
      config: {
        page: 1,
        limit: 10,
        lastPage: 0,
        total: 0,
      },
    };
  },
  computed: {
    dealerOptions() {
      return this.$store.getters.getDealer() || [];
    },
  },
  components: {
    PrintReceipt,
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    dealer() {
      this.fetchData();
    },
    status() {
      this.fetchData();
    },
    'config.page': {
      handler: 'fetchData',
    },
  },
  methods: {
    goToPage(page) {
      if (page >= 1 && page <= this.config.lastPage) this.config.page = page;
    },
    onSearchInput() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.fetchData();
      }, 400);
    },
    fetchData() {
      this.loading = true;
      const params = {};
      if (this.search && this.search.toString().trim()) {
        params.search = this.search.toString().trim();
      }
      if (this.status) {
        params.status = this.status;
      }
      if (this.dealer) {
        params.dealer = this.dealer;
      }
      params.page = this.config.page;
      params.limit = this.config.limit;
      this.$http
        .get(`/api/qrs/package`, { params })
        .then((resp) => {
          const payload = resp && resp.data ? resp.data.data || resp.data : [];
          this.rows = Array.isArray(payload)
            ? payload
            : payload && payload.rows
            ? payload.rows
            : [];
          const meta = resp && resp.data ? resp.data.meta || {} : {};
          this.config.lastPage = meta.lastPage || 1;
          this.config.total = meta.total || this.rows.length;
        })
        .catch((err) => {
          console.log(err);
          this.rows = [];
          this.config.lastPage = 1;
          this.config.total = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    isExpanded(code) {
      return !!(code && this.expandedRows[code]);
    },
    toggleIssue(code) {
      if (!code) return;
      const nextState = !this.isExpanded(code);
      this.$set(this.expandedRows, code, nextState);
      if (nextState && !this.issueRows[code] && !this.issueLoading[code]) {
        this.fetchIssue(code);
      }
    },
    fetchIssue(code) {
      if (!code) return;
      this.$set(this.issueLoading, code, true);
      this.$http
        .get(`/api/qrs/package/${code}/issue`)
        .then((resp) => {
          const payload = resp && resp.data ? resp.data.data || resp.data : [];
          const rows = Array.isArray(payload)
            ? payload
            : payload && payload.rows
            ? payload.rows
            : [];
          this.$set(this.issueRows, code, rows);
        })
        .catch((err) => {
          console.log(err);
          this.$set(this.issueRows, code, []);
        })
        .finally(() => {
          this.$set(this.issueLoading, code, false);
        });
    },
    getIssueValue(row, keys, fallback = '-') {
      if (!row) return fallback;
      const key = keys.find((k) => row[k] !== undefined && row[k] !== null && row[k] !== '');
      if (!key) return fallback;
      return row[key];
    },
    formatIssueQty(value) {
      return typeof this.numberWithCommas === 'function' ? this.numberWithCommas(value) : value;
    },
    formatIssueDate(value) {
      const date = new Date(value);
      if (isNaN(date.getTime())) return value;
      const pad = (n) => n.toString().padStart(2, '0');
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const day = pad(date.getDate());
      const month = months[date.getMonth()];
      const year = date.getFullYear();
      const hour = pad(date.getHours());
      const min = pad(date.getMinutes());
      return `${day} ${month} ${year} | ${hour}:${min}`;
    },
    async printReceiptMethod(issue) {
      try {
        const id = issue && issue.id ? issue.id : null;
        if (!id) return;
        const response = await this.$http.get(`/api/qrs/issue/${id}`);
        this.receiptData = response.data.data;
        this.$refs.printReceiptComponent.generateReport();
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
